// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D52QW7x2xMgof4v2suP8 {
  display: grid;
  grid-template-columns: repeat(3, 260px);
  grid-gap: 16px;
}

.NHjXNDkl59GJS03Dhag1 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.GfJ255idcVy9yd89OgHr {
  max-height: 175px;

  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text"]};
  font-size: 14px;
  text-align: center;

  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]};
  border-radius: 5px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  cursor: pointer;
}

.GfJ255idcVy9yd89OgHr p, .GfJ255idcVy9yd89OgHr span {
  font-size: 14px;
}

.GfJ255idcVy9yd89OgHr:hover, .yA2ivQtX0HYaawrzM043 {
  color: white;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.GfJ255idcVy9yd89OgHr:hover p, .GfJ255idcVy9yd89OgHr:hover span, .yA2ivQtX0HYaawrzM043 {
  color: white;
}

.GfJ255idcVy9yd89OgHr span {
  margin-bottom: 8px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.GfJ255idcVy9yd89OgHr p {
  margin-top: 0;
  margin-bottom: 8px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 10px;
}

.yU1XbHrnawOOdZ8zf9VX {
  display: flex;
  flex-direction: row;
  justify-content: left;
}

.yU1XbHrnawOOdZ8zf9VX > div {
    width: 49%;
    max-width: 250px;
}

.yU1XbHrnawOOdZ8zf9VX > div:first-child {
  margin-right: 8px;
}

@media screen and (max-width: 550px) {
  .D52QW7x2xMgof4v2suP8 {
    display: grid;
    grid-template-columns: repeat(1, 100%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Input/MultipleChoiceField/MultipleChoiceField.module.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mDAAmB;AACrB;;AAEA;EACE,iBAAiB;;EAEjB,mDAAiB;EACjB,eAAe;EACf,kBAAkB;;EAElB,8DAAkC;EAClC,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,8DAA8B;EAC9B,8DAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,sCAAsC;EACxC;AACF","sourcesContent":["@value colors: \"../../style/colors.css\";\r\n@value color-gray-light, color-text, color-purple-bg, color-purple from colors;\r\n\r\n.row {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 260px);\r\n  grid-gap: 16px;\r\n}\r\n\r\n.required {\r\n  color: color-purple;\r\n}\r\n\r\n.option {\r\n  max-height: 175px;\r\n\r\n  color: color-text;\r\n  font-size: 14px;\r\n  text-align: center;\r\n\r\n  border: 1px solid color-gray-light;\r\n  border-radius: 5px;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  cursor: pointer;\r\n}\r\n\r\n.option p, .option span {\r\n  font-size: 14px;\r\n}\r\n\r\n.option:hover, .optionSelected {\r\n  color: white;\r\n  background-color: color-purple;\r\n  border: 1px solid color-purple;\r\n}\r\n\r\n.option:hover p, .option:hover span, .optionSelected {\r\n  color: white;\r\n}\r\n\r\n.option span {\r\n  margin-bottom: 8px;\r\n  height: 50px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.option p {\r\n  margin-top: 0;\r\n  margin-bottom: 8px;\r\n  height: 50px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 10px;\r\n}\r\n\r\n.centeredElement {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: left;\r\n}\r\n\r\n.centeredElement > div {\r\n    width: 49%;\r\n    max-width: 250px;\r\n}\r\n\r\n.centeredElement > div:first-child {\r\n  margin-right: 8px;\r\n}\r\n\r\n@media screen and (max-width: 550px) {\r\n  .row {\r\n    display: grid;\r\n    grid-template-columns: repeat(1, 100%);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../style/colors.css"`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]}`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"row": `D52QW7x2xMgof4v2suP8`,
	"required": `NHjXNDkl59GJS03Dhag1`,
	"option": `GfJ255idcVy9yd89OgHr`,
	"optionSelected": `yA2ivQtX0HYaawrzM043`,
	"centeredElement": `yU1XbHrnawOOdZ8zf9VX`
};
export default ___CSS_LOADER_EXPORT___;
